<template>

    <section>
        <page-header>
            <slot slot="title">{{ $t('global.contact') }}</slot>
            <slot slot="description">
                <p v-if="!FormSuccess">{{ $t('global.contact_instruction') }}</p>
                <p v-else class="u-color-success-base u-font-weight-bold">{{ $t('global.contact_response') }}</p>
            </slot>
        </page-header>

        <section class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">
                <div v-if="!FormSuccess" class="u-max-700 c-form-row">

                    <!-- REDEN -->
                    <v-form-row>
                        <div class="c-contact-form-occasion">
                            <v-custom-select v-model="Contact.Occasion"
                                             :options="[ { value: 0, content: $t('global.contact') }, { value: 1, content: $t('global.complaint') }, { value: 2, content: $t('global.request_access_to_product') } ]"
                                             option-name="content"
                                             option-value="value"
                                             name="occasions"
                                             search-label="content"
                                             track-by="value"
                                             :fluid="true"
                                             :multiple="false">
                                <slot slot="label">{{ $t('global.occasion') }}</slot>
                            </v-custom-select>
                        </div>
                    </v-form-row>


                    <!-- MERK KEUZE -->
                    <v-form-row v-if="Contact.Occasion.value === 2">
                        <v-custom-select v-model="Contact.Brands"
                                         :options="BrandsOptions"
                                         option-name="Name"
                                         option-value="Code"
                                         name="brands"
                                         search-label="Name"
                                         track-by="Code"
                                         :fluid="true"
                                         :multiple="true">
                            <slot slot="label">{{ $t('branch.label.brands') }}</slot>
                        </v-custom-select>
                    </v-form-row>


                    <!-- VRAAG/OPMERKING -->
                    <v-form-row>
                        <v-textarea name="contentTextArea" v-model="Contact.Question" :fluid="true" rows="8" :autofocus="true">
                            <slot slot="label">{{ $t('preorder.remarks') }}</slot>
                        </v-textarea>
                    </v-form-row>

                    <!-- BUTTONS -->
                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal u-padding-bottom-large">
                            <v-label></v-label>
                            <button @click.prevent="submitForm" class="c-button c-button--alpha">{{ $t('warranty.send.label') }}</button>
                        </div>
                    </v-form-row>

                </div>
            </form>
        </section>
    </section>

</template>

<script>
    import Vue from 'vue'
    import PageHeader from '@/components/common/PageHeader'

    // Forms
    import VTextarea from '@/components/form/Textarea'
    import VInput from '@/components/form/Input'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VSwitch from '@/components/form/Switch'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            VTextarea,
            VSelect,
            VCustomSelect,
            VLabel,
            VInput,
            VFormRow,
            VSwitch
        },
        data() {
            return {
                Contact: {
                    Occasion: {},
                    Brands: [],
                    Question: null
                },
                FormSuccess: false,
                Validate: {},
                ProductName: ''
            }
        },
        created() {
            this.$store.dispatch('getBrandsOptions');
            this.ProductName = this.$store.getters.ProductAccessRequested;
            this.$store.dispatch('clearProductAccessRequested');
            if(this.ProductName){
                this.Contact.Question = this.ProductName;
            }

            if (this.$route.params.Brand) {
                this.$set(this.Contact, 'Occasion', { value: 2, content: this.$t('global.request_access_to_product') });
                this.$set(this.Contact, 'Brands', this.BrandsOptions.find((obj) => { return obj.Code === this.$route.params.Brand; }));
            }
        },
        computed: {
            ...mapGetters({
                BrandsOptions: 'BrandsOptions'
            })
        },
        methods: {
            validateForm(response){
                let errors = response.data.ModelState;

                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });

                this.Validate = errors;
            },
            submitForm() {
                this.$store.dispatch('sendContactForm', this.Contact).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                    } else {
                        this.FormSuccess = true;
                    }
                });
            }
        },
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/private";

</style>


// WEBPACK FOOTER //
// src/views/common/Contact.vue